export const SystemSourceId = 'SYSTEM';
export const LanguageVariableToken = 'LANG';
